import {UserRole} from "@models/role.model";

import {UserBusinessType} from "@models/enums/user-business-type.enum";

export class User {

    public id: number;
    public firstName: string;
    public lastName: string;
    public boschId: string;
    public email: string;
    public roles: UserRole[];
    public isActive: boolean;
    public name: string;
    public username: string;
    public isADUser: boolean;
    public userBusinessType?: UserBusinessType;

    private resultIndex: number;

    static toUserBusinessType(value: UserBusinessType | string | number | null | undefined): UserBusinessType | undefined {
        if (value === null || value === undefined || value === '') {
            return undefined;
        }

        if (typeof value === 'number' && UserBusinessType[value] !== undefined) {
            return value;
        }

        if (typeof value === 'string') {
            const numericValue = Number(value);

            if (!Number.isNaN(numericValue) && UserBusinessType[numericValue] !== undefined) {
                return numericValue;
            }

            const enumValue = UserBusinessType[value as keyof typeof UserBusinessType];
            return typeof enumValue === 'number' ? enumValue : undefined;
        }

        return undefined;
    }

    get index() {
        return this.resultIndex;
    }

    set index(resultIndex) {
        this.resultIndex = resultIndex;
    }

    get fullName() {
        if (!this.firstName && !this.lastName) {
            return null;
        }
        return `${this.firstName} ${this.lastName}`;
    }

    get roleNames() {
        return this.roles.map(role => role.name).join(', ');
    }

    constructor(user: any = {}) {
        this.id = user.id || 0;
        this.firstName = user.firstName || '';
        this.lastName = user.lastName || '';
        this.boschId = user.boschId;
        this.email = user.email || '';
        const roles = user.Roles || user.roles || (user.role ? [user.role] : []);
        this.roles = roles.map((item: any) => new UserRole(item));
        this.isActive = user.isActive;
        this.name = this.fullName || user.name;
        this.username = user.username || '';
        this.isADUser = user.isADUser;
        this.userBusinessType = User.toUserBusinessType(user.userBusinessType);
    }

    get type() {
        return 'user';
    }
}
